/*
*###############################################################################
*Module Name                   : TransactionHED.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Thursday, October 14th 2021, 10:06:06 am      #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
/* Import reactstrap Libries */
import { CardText, Col, Row, Alert, Button, Modal, Table } from 'reactstrap'
/* End Import reactstrap Libries */

/* Import myPOS Framework Component */
import DPTextBox from 'framework/components/DPTextBox'
import DPDropDown from "framework/components/DPDropDown"
import DPSearchBox from 'framework/components/DPSearchBox'
import DPTextBoxWithDropDown from 'framework/components/DPTextBoxWithDropDown'
import DPTextBoxWithButton from 'framework/components/DPTextBoxWithButton'
import DPAlert from "../../../framework/widgets/DPAlert"
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'
import { GetSearchTable } from "../Transaction/TransactionController"
import DPSearchBoxDynamicRefTxn from 'framework/components/DPSearchBoxDynamicRefTxn'
import DPTextBoxTow from 'framework/components/DPTextBoxTow'
import DPTextBoxTowButton from 'framework/components/DPTextBoxTowButton'
import { Context } from "app-contexts/CommonContexts"
import { useContext } from "react"
import { Link } from 'react-router-dom/cjs/react-router-dom.min'


/* End Import myPOS Framework Component */

/* Import Content widgets */

/* End Import Content widgets */

const TransactionHED = ({
    CodeValue,
    CodeonChange,
    Remarks1Value,
    Remarks1OnChange,
    Remarks2Value,
    Remarks2OnChange,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    SupmodelOpen,
    SAmodelOpen,
    CusmodelOpen,
    BommodelOpen,
    PromodelOpen,
    BommodelTrigger,
    PromodelTrigger,
    RefmodelOpen,
    modelTrigger,
    SupmodelTrigger,
    CusmodelTrigger,
    SAmodelTrigger,
    RefmodelTrigger,
    GetSelectRow,
    GetRefSelectRow,
    GetSupSelectRow,
    GetCusSelectRow,
    GetProSelectRow,
    GetBomSelectRow,
    GetSASelectRow,
    disabledCode,
    disabledRemarks,
    disabledPriceMode,
    disabledCustomer,
    disabledDate,
    disabledSupplier,
    disabledRefType,
    disabledSA,
    disabledFL,
    disabledTL,
    disabledDL,
    CodeOnBlur,
    ErrorMsg,
    fromLocationSelect,
    fromLocationOnChange,
    toLocationSelect,
    toLocationOnChange,
    deliLocationSelect,
    deliLocationOnChange,
    customerSelect,
    customerSelectName,
    customerTypeOnchange,
    customerOnBlur,
    customerOnChange,
    salesAssistantSelect,
    bomSelect,
    bomSelectName,
    bomOnChange,
    bomOnBlur,
    proSelect,
    proSelectName,
    saleAssistantSelectName,
    salesAssistantOnChange,
    priceModeSelect,
    priceModeOnChange,
    supplierSelect,
    supplierSelectName,
    supplierOnChange,
    supplierOnBlur,
    txnDate,
    txnDateOnChange,
    txn,
    type,
    RefCode,
    txRefAmount,
    SetRefAmount,
    RefCodeOnChange,
    RefCodeOnBlur,
    validDay,
    SetValidDay,
    refTypeOption,
    refTypeSelected,
    refTypeOnchange,
    SetRefTypeSelected,
    SetFromLocationSelect,
    menuCode,
    fromLocations,
    toLocations,
    SetLocation,
    validToDate,
    validFromDate,
    SetValidFromDate,
    SetValidToDate,
    DataRow,
    RefDataRow,
    summaryRemarksList,
    handleClearStatus,
    salesAssistOnBlur,
    salesAssistOnchange,
    finishProOnchange,
    finishProOnBlur,
    RefAmountOnBlur,
    LocationCode,
    glBatchNo
}) => {


    const {
        isWMS
    } = useContext(Context);

    //*** useState for hold Header Values */
    const [DataTables, SetDatatable] = useState([])
    const [arSupplier, SetSupplier] = useState([])
    const [arCustomer, SetCustomer] = useState([])
    const [arSalesAssistant, SetSalesAssistant] = useState([])
    const [arPriceMode, SetPriceMode] = useState([])
    const [arRefTypes, SetRefTypes] = useState([])
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const ApiURL = window.Links.ApiURL

    const [columnsSupp, setColumnsSupp] = useState([])
    const [columnsCus, setColumnsCus] = useState([])
    const [columnsPro, setColumnsPro] = useState([])
    const [columnsBom, setColumnsBom] = useState([])
    const [txvgroupFilter, SetTxnGroupFilter] = useState('a')
    const [groupFilter, SetGroupFilter] = useState('a')
    const [CusgroupFilter, SetCusGroupFilter] = useState('a')
    const [SAgroupFilter, SetSAGroupFilter] = useState('a')
    const [ProgroupFilter, SetProGroupFilter] = useState('a')
    const [payColumn, SetPayColumn] = useState('')
    //*** End of useStates */

    const authToken = localStorage.getItem("authToken")


    useEffect(async () => {

        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                redirect: 'follow'
            };

            const response = await fetch(`${ApiURL}pricemode/select`, requestOptions);
            const result = await response.json();

            if (result.success) {
                SetPriceMode(result.data)
            } else {
                SetPriceMode([])
            }

        } catch (error) {
            console.error('Error:', error);
        }



        if (txn.intTX_FROMLOCSETUP == 1) {
            //debugger;
            fromLocationOnChange({ value: txn.strSETUP_LOCATION, label: "" })
        }
        if (txn.intTX_TOLOCSETUP == 1) {
            //debugger;
            toLocationOnChange({ value: txn.strSETUP_LOCATION, label: "" })
        }

        if (txn.strTX_SUPPLIERGRP && txn.strTX_SUPPLIERGRP.trim() !== '') {
            const TX_SUPPLIERGRP = txn.strTX_SUPPLIERGRP.split(',');
            const txt = "AND SM_GROUP IN ('" + TX_SUPPLIERGRP.join("','") + "')";
            SetGroupFilter(txt);
        } else {
            SetGroupFilter("a");
        }

        if (txn.strTX_CUSTOMERGRP && txn.strTX_CUSTOMERGRP.trim() !== '') {
            const TX_CUSTOMERGRP = txn.strTX_CUSTOMERGRP.split(',');
            const txt = "AND CM_GROUP IN ('" + TX_CUSTOMERGRP.join("','") + "')";
            SetCusGroupFilter(txt);
        } else {
            SetCusGroupFilter("a");
        }

        if (txn.intTX_SAVEINVOICE == 1) {
            SetPayColumn('INVHED_INVNO')
        } else if (txn.intTX_SAVEINVOICE == 0) {
            SetPayColumn('HED_RUNNO')
        } else {
            SetPayColumn('')
        }

    }, [txn]);


    useEffect(async () => {

        let transactionFilter = txn.intTX_SAVEINVOICE == 1 ? `AND INVHED_LOGLOCATION = '${LocationCode}'` : isWMS ? 'a' : `AND HED_LOGLOCATION = '${LocationCode}'`

        SetTxnGroupFilter(transactionFilter)
    }, [txn, LocationCode])



    useEffect(async () => {

        if (txn.strTX_REFTYPES) {
            const txnTypes = txn.strTX_REFTYPES.split(",");
            const txnAr = txnTypes.map((item) => ({ label: item, value: item }));

            if (!refTypeSelected && txnAr.length > 0) {
                SetRefTypeSelected(txnAr[0].value);
            } else {
                SetRefTypeSelected("")
            }
            SetRefTypes(txnAr);
        }

    }, [handleClearStatus, txn.strTX_REFTYPES])



    async function tog_backdrop() {
        modelTrigger();
    }


    //**Set the Default sort column and Sort order*/
    const defaultSortedSup = [
        {
            dataField: "id",
            order: "asc",
        },
    ]

    //default sorted method
    const defaultSortedCus = [{
        dataField: 'id',
        order: 'asc'
    }];

    //**Set the Default sort column and Sort order*/
    const defaultSortedSA = [
        {
            dataField: "id",
            order: "asc",
        },
    ]


    async function tog_backdropRef() {

        if (fromLocationSelect == '' && txn.intTX_SHOWVAR == 0) {
            setAlertDescription("Please Select Location Before Load The Reference Document !")
            setAlertConfirmOption(1)
            setsweetAlertShow(true)
            return;
        }

        if (fromLocationSelect == "") {
            setAlertDescription("Please Select From Location Before Load The Reference Document !")
            setAlertConfirmOption(1)
            setsweetAlertShow(true)
            return;
        }

        if (toLocationSelect == "" && txn.strTX_DESTINV != 'N' && txn.strTX_DESTINV != '') {
            setAlertDescription("Please Select To Location Before Load The Reference Document !")
            setAlertConfirmOption(1)
            setsweetAlertShow(true)
            return;
        }

        RefmodelTrigger();
    }


    //modal props
    const columnsRef = [
        { dataField: 'HED_RUNNO', title: 'Document No', sort: true, align: 'center' },
        { dataField: 'HED_TXNDATE', title: 'Date', sort: true, align: 'center' },
        { dataField: 'HED_SUPCODE', title: 'Supplier', sort: true, align: 'center' },
        { dataField: 'SM_NAME', title: 'Name', sort: true, align: 'center' },
        { dataField: 'HED_PROCESSED', title: 'Processed', sort: true, align: 'center' },
        { dataField: 'HED_NETAMT', title: 'Amount', sort: true, align: 'center' },
        { dataField: 'HED_LOCFROM', title: 'From Loc', sort: true, align: 'center' },
        { dataField: 'HED_LOCTO', title: 'To Loc', sort: true, align: 'center' },
        { dataField: 'HED_REF1', title: 'Remarks1', sort: true, align: 'center' },
        { dataField: 'HED_REF2', title: 'Remarks2', sort: true, align: 'center' },
    ];

    //default sorted method
    const defaultSorted = [{ dataField: 'code', order: 'desc' }];


    const KeyPressEvnt = async (e) => {
        try {
            if (e.charCode === 13) {
                const focusMap = {
                    "txtCode": e.target.value === '' ? 'txtDate' : (await CodeOnBlur(CodeValue), null),
                    "txtDate": txn.strTX_SOURCEINV !== 'N' ? 'txtFromLoc' :
                        (txn.strTX_DESTINV !== 'N' ? 'txtToLoc' :
                            (txn.intTX_SUPPLIER === 1 ? 'txtSupplier' :
                                (txn.intTX_CUSTOMER === 1 ? 'txtCustomer' :
                                    (txn.intTX_SALESBY === 1 ? 'txtSA' :
                                        (txn.intTX_PRICEMODE === 1 ? 'txtPriceMode' :
                                            (txn.strTX_REFTYPES !== "" ? 'txtRefNo' : 'txtRemarks1')))))),
                    "txtFromLoc": (txn.strTX_DESTINV !== 'N' ? 'txtToLoc' :
                        (txn.intTX_SUPPLIER === 1 ? 'txtSupplier' :
                            (txn.intTX_CUSTOMER === 1 ? 'txtCustomer' :
                                (txn.intTX_SALESBY === 1 ? 'txtSA' :
                                    (txn.intTX_PRICEMODE === 1 ? 'txtPriceMode' :
                                        (txn.strTX_REFTYPES !== "" ? 'txtRefNo' : 'txtRemarks1')))))),
                    "txtToLoc": (txn.strTX_DESTINV !== 'N' ? 'txtDeliLoc' :
                        (txn.intTX_SUPPLIER === 1 ? 'txtSupplier' :
                            (txn.intTX_CUSTOMER === 1 ? 'txtCustomer' :
                                (txn.intTX_SALESBY === 1 ? 'txtSA' :
                                    (txn.intTX_PRICEMODE === 1 ? 'txtPriceMode' :
                                        (txn.strTX_REFTYPES !== "" ? 'txtRefNo' : 'txtRemarks1')))))),
                    "txtDeliLoc": (txn.intTX_SUPPLIER === 1 ? 'txtSupplier' :
                        (txn.intTX_CUSTOMER === 1 ? 'txtCustomer' :
                            (txn.intTX_SALESBY === 1 ? 'txtSA' :
                                (txn.intTX_PRICEMODE === 1 ? 'txtPriceMode' :
                                    (txn.strTX_REFTYPES !== "" ? 'txtRefNo' : 'txtRemarks1'))))),
                    "txtSupplier": (txn.intTX_CUSTOMER === 1 ? 'txtCustomer' :
                        (txn.intTX_SALESBY === 1 ? 'txtSA' :
                            (txn.intTX_PRICEMODE === 1 ? 'txtPriceMode' :
                                (txn.strTX_REFTYPES !== "" ? 'txtRefNo' : 'txtRemarks1')))),
                    "txtCustomer": (txn.intTX_SALESBY === 1 ? 'txtSA' :
                        (txn.intTX_PRICEMODE === 1 ? 'txtPriceMode' :
                            (txn.strTX_REFTYPES !== "" ? 'txtRefNo' : 'txtRemarks1'))),
                    "txtSA": (txn.intTX_PRICEMODE === 1 ? 'txtPriceMode' :
                        (txn.strTX_REFTYPES !== "" ? 'txtRefNo' : 'txtRemarks1')),
                    "txtPriceMode": (txn.strTX_REFTYPES !== "" ? 'txtRefNo' : 'txtRemarks1'),
                    "txtRefNo": 'txtRemarks1',
                    "txtRemarks1": 'txtRemarks2',
                    // Add more mappings as needed
                };

                const nextFocusElement = focusMap[e.target.id];
                if (nextFocusElement) {
                    const nextElement = document.getElementById(nextFocusElement);
                    if (nextElement) {
                        nextElement.focus();
                    }
                }

            }
        } catch (error) {
            console.log(error)
        }
    };

    //* End Key Press Event */

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={6} className="mb-4-sm">
                                <DPTextBoxWithButton
                                    rowClass="mb-4-sm mb-0"
                                    labelText="Doc. No."
                                    textType="text"
                                    maxLength={13}
                                    value={CodeValue}
                                    onChange={CodeonChange}
                                    disabled={disabledCode}
                                    onBlur={() => { CodeOnBlur(CodeValue) }}
                                    id={"txtCode"}
                                    onKeyPress={e => {
                                        KeyPressEvnt(e)
                                    }}
                                    //onClickBtn={modelTrigger}
                                    onClickBtn={() => {
                                        tog_backdrop()
                                    }}
                                />

                                {txn.intTX_SUPPLIER == 1 ? (
                                    <DPTextBoxTowButton
                                        textType={"text"}
                                        rowClass={"mb-4-sm mb-1"}
                                        labelText="Supplier *"
                                        value1={supplierSelect}
                                        value2={supplierSelectName}
                                        onChange1={supplierOnChange}
                                        onBlur1={supplierOnBlur}
                                        id={"txtSupplier"}
                                        onKeyPress1={e => {
                                            KeyPressEvnt(e)
                                        }}
                                        onClickBtn={SupmodelTrigger}
                                        disabled1={disabledSupplier ? true : txn.intTX_ORDER_TRANSACTION == 1 && txn.intTX_LOCATION_RELATED_SUPPLIER == 1 ? true : DataRow.some(x => x.strDET_PROCODE != "") ? true : false}
                                        disabled2={true}
                                    />
                                ) : null}

                                {txn.intTX_CUSTOMER == 1 ? (
                                    <DPTextBoxTowButton
                                        rowClass={"mb-4-sm mb-1"}
                                        labelText={"Customer"}
                                        textType={"text"}
                                        value1={customerSelect}
                                        value2={customerSelectName}
                                        onChange1={customerTypeOnchange}
                                        onBlur1={customerOnBlur}
                                        id={"txtCustomer"}
                                        onKeyPress1={e => {
                                            KeyPressEvnt(e)
                                        }}
                                        onClickBtn={CusmodelTrigger}
                                        disabled1={disabledCustomer ? true : DataRow.some(x => x.strDET_PROCODE != "") ? true : false}
                                        disabled2={true}

                                    />
                                ) : null}
                                {txn.intTX_SALESBY == 1 ? (
                                    <DPTextBoxTowButton
                                        rowClass={"mb-4-sm mb-1"}
                                        labelText={txn.strTX_SALESBYCAPTION == "" ? "Sales Assist" : txn.strTX_SALESBYCAPTION}
                                        textType={"text"}
                                        value1={salesAssistantSelect}
                                        value2={saleAssistantSelectName}
                                        onChange1={salesAssistOnchange}
                                        onBlur1={salesAssistOnBlur}
                                        id={"txtSA"}
                                        onKeyPress1={e => {
                                            KeyPressEvnt(e)
                                        }}
                                        onClickBtn={SAmodelTrigger}
                                        disabled1={disabledSA ? true : DataRow.some(x => x.strDET_PROCODE != "") ? true : false}
                                        disabled2={true}

                                    />

                                ) : null}

                                {/* show price mode */}
                                {txn.intTX_SHOWPRICEMODE == 1 ? (
                                    <DPDropDown
                                        rowClass={"mb-4-sm mb-0 mt-2"}
                                        labelText="Price Mode *"
                                        optionGroup={arPriceMode}
                                        selectedGroup={priceModeSelect}
                                        onChange={priceModeOnChange}
                                        disabled={disabledPriceMode ? true : DataRow.some(x => x.strDET_PROCODE != "") ? true : false}
                                        id={"txtPriceMode"}
                                        onKeyPress={e => {
                                            KeyPressEvnt(e)
                                        }}
                                    />
                                ) : null}

                                {/* Show ledger batch no */}
                                {txn.intTX_MYLEDGER == 1 ? (
                                    <DPTextBox
                                        rowClass="mb-4-sm mb-0"
                                        labelText="GL Batch No"
                                        textType="text"
                                        value={glBatchNo}
                                        id={"glBatchNo"}
                                        disabled={true}
                                    />
                                ) : null}

                                {/* show reference 1 */}
                                {txn.strTX_REF1 != '' ? (
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText={txn.strTX_REF1}
                                        textType="text"
                                        maxLength={50}
                                        value={Remarks1Value}
                                        onChange={Remarks1OnChange}
                                        disabled={disabledRemarks ? true : txn.intTX_REF1_DISABLE == 1 ? true : false}
                                        id={"txtRemarks1"}
                                        onKeyPress={e => {
                                            KeyPressEvnt(e)
                                        }}
                                    />) : null}

                                {/* show reference 2 */}
                                {txn.strTX_REF2 != '' ? (
                                    <DPDropDown
                                        rowClass="mb-4-sm"
                                        labelText={txn.strTX_REF2}
                                        optionGroup={summaryRemarksList}
                                        selectedGroup={Remarks2Value}
                                        onChange={Remarks2OnChange}
                                        disabled={disabledRemarks ? true : txn.intTX_REF2_DISABLE == 1 ? true : false}
                                        id={"txtRemarks2"}
                                        onKeyPress={e => {
                                            KeyPressEvnt(e)
                                        }}
                                        iconShow={true}
                                    />
                                ) : null}


                                {/* BOM Finish product selection  */}
                                {txn.intTX_BOM == 1 ? (
                                    <DPTextBoxTowButton
                                        rowClass={"mb-4-sm"}
                                        labelText={"Finish Product *"}
                                        textType={"text"}
                                        value1={proSelect}
                                        value2={proSelectName}
                                        onChange1={finishProOnchange}
                                        onBlur1={finishProOnBlur}
                                        id={"txtFinishProduct"}
                                        onKeyPress1={e => {
                                            KeyPressEvnt(e)
                                        }}
                                        onClickBtn={PromodelTrigger}
                                        disabled1={disabledSupplier ? true : DataRow.some(x => x.strDET_PROCODE != "") ? true : false}
                                        disabled2={true}
                                    />

                                ) : null}


                                {/* Select bom menu according to he selected finish product */}
                                {txn.intTX_BOM == 1 ? (
                                    <DPTextBoxTowButton
                                        rowClass={"mb-4-sm"}
                                        labelText={"BOM/Menu"}
                                        textType={"text"}
                                        value1={bomSelect}
                                        value2={bomSelectName}
                                        onChange1={bomOnChange}
                                        onBlur1={bomOnBlur}
                                        id={"txtBOM"}
                                        onKeyPress1={e => {
                                            KeyPressEvnt(e)
                                        }}
                                        onClickBtn={BommodelTrigger}
                                        disabled1={disabledSupplier ? true : DataRow.some(x => x.strDET_PROCODE != "") ? true : false}
                                        disabled2={true}
                                    />
                                ) : null}
                            </Col>
                            <Col sm={12} md={1} className="mb-4-sm">
                            </Col>
                            <Col sm={12} md={5} className="mb-4-sm">
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Date"
                                    textType="date"
                                    value={txnDate}
                                    onChange={txnDateOnChange}
                                    disabled={txn.intTX_DISABLEDATE == 1 ? true : disabledDate.txtDate}
                                    id={"txtDate"}
                                    onKeyPress={e => {
                                        KeyPressEvnt(e)
                                    }}
                                />
                                {txn.intTX_VALDAYS == 1 ? (<DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText={txn.strTX_VALIDDAYSCAP == '' ? "Valid Until" : txn.strTX_VALIDDAYSCAP}
                                    textType="date"
                                    value={validDay}
                                    onChange={SetValidDay}
                                    disabled={txn.intTX_TILDATE_DISABLE == 1 ? true : disabledDate.validDate}
                                    id={"txtValidDate"}
                                    onKeyPress={e => {
                                        KeyPressEvnt(e)
                                    }}
                                />) : null}
                                {txn.strTX_SOURCEINV == 'N' || txn.strTX_SOURCEINV == '' ? null : (
                                    <DPDropDown
                                        rowClass="mb-4-sm"
                                        labelText="From Location *"
                                        optionGroup={fromLocations}
                                        selectedGroup={fromLocationSelect}
                                        onChange={fromLocationOnChange}
                                        disabled={disabledFL ? true : DataRow.some(x => x.strDET_PROCODE != "") ? true : false}
                                        id={"txtFromLoc"}
                                        onKeyPress={e => {
                                            KeyPressEvnt(e)
                                        }}
                                        iconShow={true}
                                        impactColor={txn.strTX_SOURCEINV}
                                    />
                                )}
                                {txn.strTX_DESTINV == 'N' || txn.strTX_DESTINV == '' ? null : (
                                    <DPDropDown
                                        rowClass="mb-4-sm"
                                        labelText="To Location *"
                                        optionGroup={toLocations}
                                        selectedGroup={toLocationSelect}
                                        onChange={toLocationOnChange}
                                        disabled={disabledTL ? true : DataRow.some(x => x.strDET_PROCODE != "") ? true : false}
                                        id={"txtToLoc"}
                                        onKeyPress={e => {
                                            KeyPressEvnt(e)
                                        }}
                                        iconShow={true}
                                        impactColor={txn.strTX_DESTINV}
                                    //disabled={Gen_Supplier_Enabled}
                                    />)}
                                {txn.strTX_DELINV == 'N' || txn.strTX_DELINV == '' ? null : (<DPDropDown
                                    rowClass="mb-4-sm"
                                    labelText="Location (Delivery/Collection)"
                                    optionGroup={fromLocations} /// need to change to deli location
                                    selectedGroup={deliLocationSelect}
                                    onChange={deliLocationOnChange}
                                    disabled={disabledDL}
                                    id={"txtDeliLoc"}
                                    onKeyPress={e => {
                                        KeyPressEvnt(e)
                                    }}
                                //disabled={Gen_Supplier_Enabled}
                                />)}
                                {/*<DPDropDown
                                    rowClass="mb-4-sm"
                                    labelText="Ref. Type"
                                    optionGroup={fromLocation}
                                //selectedGroup={Gen_Supplier}
                                //onChange={Gen_Supplier_OnChange}
                                //disabled={Gen_Supplier_Enabled}
                                />*/}
                                {/* txn.strTX_REFTYPES == "" && SATXN != txn.strTX_TYPE  */}
                                {txn.strTX_REFTYPES == "" || txn.strTX_REFTYPES == null ? null : (
                                    <Row>
                                        <DPTextBoxWithDropDown
                                            rowClass="mb-4-sm"
                                            labelText={"Ref.Doc. No. *"}
                                            textType="text"
                                            maxLength="50"
                                            value={RefCode}
                                            onChange={RefCodeOnChange}
                                            onBlur={RefCodeOnBlur}
                                            disabled={RefDataRow.length > 0 || DataRow.some(x => x.strDET_PROCODE != "") ? true : disabledRefType}
                                            id={"txtRefNo"}
                                            onKeyPress={e => {
                                                KeyPressEvnt(e)
                                            }}
                                            optionGroup={arRefTypes}
                                            selectedGroup={refTypeSelected}
                                            onChangeDrop={refTypeOnchange}
                                            onClickBtn={() => {
                                                tog_backdropRef()
                                            }}
                                            loadRefTransacton={RefDataRow.length > 0 && txn.intTX_FROMHO == 0}
                                            refButtonClickValue={`/Transaction?${refTypeSelected}&${RefCode}&${fromLocationSelect}`}
                                        />
                                    </Row>
                                )}
                                {txn.intTX_CHKREFAMT == 1 ?
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText={"Ref. Amount *"}
                                        textType="text"
                                        maxLength="50"
                                        textAlign={'right'}
                                        value={txRefAmount}
                                        onChange={SetRefAmount}
                                        disabled={disabledRefType}
                                        onBlur={RefAmountOnBlur}
                                        id={"txtRefAmt"}
                                        onKeyPress={e => {
                                            KeyPressEvnt(e)
                                        }}
                                    />
                                    : null
                                }
                                {txn.intTX_VALIDFROMDATE == 1 ? (<DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText={txn.strTX_VALIDFROMDATE_CAPTION == '' ? "Valid From *" : txn.strTX_VALIDFROMDATE_CAPTION}
                                    textType="date"
                                    value={validFromDate}
                                    onChange={SetValidFromDate}
                                    disabled={disabledDate.validFromDate ? true : parseInt(txn.intTX_VALIDTILLDATE) > 0 ? true : false}
                                    id={"txtValidFromDate"}
                                    onKeyPress={e => {
                                        KeyPressEvnt(e)
                                    }}
                                />) : null}
                                {txn.intTX_VALIDTODATE == 1 ? (<DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText={txn.strTX_VALIDTODATE_CAPTION == '' ? "Valid To *" : txn.strTX_VALIDTODATE_CAPTION}
                                    textType="date"
                                    value={validToDate}
                                    onChange={SetValidToDate}
                                    disabled={disabledDate.validToDate ? true : parseInt(txn.intTX_VALIDTILLDATE) > 0 ? true : false}
                                    id={"txtValidToDate"}
                                    onKeyPress={e => {
                                        KeyPressEvnt(e)
                                    }}
                                />) : null}
                            </Col>

                            {payColumn.length > 1 ? (<DPSearchBoxDynamic
                                searchData={DataTables}
                                columns={[]}
                                defaultSorted={defaultSortedSup}
                                mainTitle={txn.strTX_DESC + " Search "}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"TRANSACTION"}
                                MenuCode={menuCode}
                                KeyVal={'TXN'}
                                searchBy={payColumn}
                                FilterStr={txvgroupFilter}
                                orderBy={"DESC"}
                            />) : null}
                            <DPSearchBoxDynamic
                                searchData={DataTables}
                                columns={columnsPro}
                                defaultSorted={defaultSortedSup}
                                mainTitle={"Finish Product Search "}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={PromodelOpen}
                                toggle={PromodelTrigger}
                                getSelect={GetProSelectRow}
                                APIURL={ApiURL}
                                URLPath={"FINALPRO"}
                                MenuCode={menuCode}
                                KeyVal={'TXN'}
                                searchBy={'PLU_CODE'}
                                FilterStr={ProgroupFilter}
                            />
                            <DPSearchBoxDynamic
                                searchData={DataTables}
                                columns={columnsBom}
                                defaultSorted={defaultSortedSup}
                                mainTitle={"BOM / Menu Search "}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={BommodelOpen}
                                toggle={BommodelTrigger}
                                getSelect={GetBomSelectRow}
                                APIURL={ApiURL}
                                URLPath={"BOM"}
                                MenuCode={menuCode}
                                KeyVal={'TXN'}
                                searchBy={'BOM_CODE'}
                                FilterStr={"AND BOM_FINISHPRO = '" + proSelect + "'"}
                            />
                            <DPSearchBoxDynamic
                                searchData={arSupplier}
                                columns={columnsSupp}
                                defaultSorted={defaultSortedSup}
                                mainTitle={"Supplier Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={SupmodelOpen}
                                toggle={SupmodelTrigger}
                                getSelect={GetSupSelectRow}
                                APIURL={ApiURL}
                                URLPath={"SUPPLIER"}
                                MenuCode={menuCode}
                                KeyVal={'TXN'}
                                searchBy={'SM_CODE'}
                                FilterStr={groupFilter}
                            />
                            <DPSearchBoxDynamic
                                searchData={arCustomer}
                                columns={columnsCus}
                                defaultSorted={defaultSortedCus}
                                mainTitle={"Customer Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={CusmodelOpen}
                                toggle={CusmodelTrigger}
                                getSelect={GetCusSelectRow}
                                APIURL={ApiURL}
                                URLPath={"CUSTOMER"}
                                MenuCode={menuCode}
                                KeyVal={'TXN'}
                                searchBy={'CM_CODE'}
                                FilterStr={CusgroupFilter}
                            />
                            <DPSearchBoxDynamic
                                searchData={arSalesAssistant}
                                columns={[]}
                                defaultSorted={defaultSortedSA}
                                mainTitle={"Sales Assistant Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={SAmodelOpen}
                                toggle={SAmodelTrigger}
                                getSelect={GetSASelectRow}
                                APIURL={ApiURL}
                                URLPath={"SA"}
                                MenuCode={menuCode}
                                KeyVal={'TXN'}
                                searchBy={'SA_CODE'}
                                FilterStr={SAgroupFilter}
                            />
                            <DPSearchBoxDynamicRefTxn
                                searchData={DataTables}
                                columns={columnsRef}
                                defaultSorted={defaultSorted}
                                mainTitle={`Transaction Search (${refTypeSelected})`}
                                SelectType={'radio'}//checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={RefmodelOpen}
                                toggle={RefmodelTrigger}
                                getSelect={GetRefSelectRow}
                                fromLocationSelect={fromLocationSelect}
                                toLocationSelect={toLocationSelect}
                                intTX_SHOWVAR={txn.intTX_SHOWVAR}
                                refTypeSelected={refTypeSelected}
                                txnType={type.toUpperCase()}
                                orderBy={"DESC"}
                            />
                        </Row>
                        <Row>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                        </Row>
                        <Row>
                            <DPAlert
                                confirm_both={sweetAlertShow}
                                title={txn.strTX_DESC}
                                description={AlertDescription}
                                showCancel={false}
                                btnColor={"success"}
                                cancelColor={"danger"}
                                onConfirm={() => {
                                    setsweetAlertShow(false)
                                }}
                                btnYes={"OK"}
                            />
                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    );
}

export default TransactionHED